<template>
  <div class="container-fluid">
    <div class="container-fuild mt-2">
      <ol class="breadcrumb text-big py-3 m-0">
        <li v-for="item in breadCrumbs" :key="item.id" class="breadcrumb-item">
          <a href="#" @click="get(item.id)">{{ item.name }}</a>
        </li>
      </ol>
      <hr class="m-0" />
      <div class="file-manager-actions py-1">
        <button
          type="button"
          class="btn btn-info"
          @click="
            () => {
              view = VIEW_LIST;
            }
          "
        >
          <i class="fa fa-list"></i>
        </button>
        <button
          type="button"
          class="btn btn-info"
          @click="
            () => {
              view = VIEW_GRID;
            }
          "
        >
          <i class="fa fa-th"></i>
        </button>

        <button
          type="button"
          class="btn btn-primary"
          @click="openNewFolderModal()"
          v-if="$currentUserCan($permissions.PERM_CREATE_FOLDERS) && !query"
        >
          <i class="fa fa-folder"></i>&nbsp;
          {{ $t("FILES.NEW_FOLDER") }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          v-if="
            $currentUserCan($permissions.PERM_CREATE_FILES) &&
            !!currentFolder.id && !query
          "
          @click="openNewFileModal()"
        >
          <i class="fa fa-upload"></i>&nbsp;
          {{ $t("FILES.NEW_FILE") }}
        </button>

        <div class="col-6 d-inline-block">
          <base-input
            v-model="query"
            type="search"
            prepend-icon="fas fa-search"
            :placeholder="$t('COMMON.SEARCH_HINT.FILE_OR_FOLDER')"
            clearable
          />
        </div>
        <notification-subscription
          v-if="$currentUserCan($permissions.PERM_VIEW_FILES)"
          :objectType="'files'"
          :events="{
            CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
            UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
            DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
          }"
        />

        <base-dropdown v-if="canDoActions()">
          <base-button
            slot="title-container"
            type="info"
            class="dropdown-toggle"
          >
            <i class="fa fa-cog"></i>
          </base-button>
          <li>
            <a
              class="dropdown-item"
              href="#"
              v-if="canOpenLocation()"
              @click.prevent="openSelectedLocation()"
            >
              <i class="ni ni-pin-3"></i>
              {{ $t("FILES.OPEN_LOCATION") }}
            </a>
            <a
              class="dropdown-item"
              href="#"
              v-if="canEdit()"
              @click="openEditModal()"
            >
              <i class="fa fa-edit"></i>
              {{ $t("FILES.EDIT") }}
            </a>
            <a
              class="dropdown-item"
              href="#"
              v-if="canViewHistory()"
              @click="openFileHistoryModal()"
            >
              <i class="ni ni-book-bookmark"></i>
              {{ $t("FILES.FILE_HISTORY") }}
            </a>
            <a
              class="dropdown-item"
              href="#"
              @click="deleteItems()"
              v-if="canDelete()"
            >
              <i class="fa fa-trash"></i>
              {{ $t("FILES.REMOVE") }}
            </a>
          </li>
        </base-dropdown>
      </div>
      <hr class="m-0" />
    </div>

    <files-grid
      v-if="view == VIEW_GRID"
      :key="renderKey"
      :folder="currentFolder"
      :folderData="folderData"
      :query="query"
      @onNavigateTo="
        (id) => {
          get(id);
        }
      "
      @onSelectItems="
        (items) => {
          selectedItems = items;
        }
      "
    />

    <files-list
      v-if="view == VIEW_LIST"
      :key="renderKey"
      :folder="currentFolder"
      :folderData="folderData"
      :query="query"
      @onNavigateTo="
        (id) => {
          get(id);
        }
      "
      @onSelectItems="
        (items) => {
          selectedItems = items;
        }
      "
    />

    <!-- MODALS -->
    <folder-form-modal
      v-if="showFolderFormModal"
      :currentFolder="currentFolder"
      :folderData="folderData"
      :showModal="showFolderFormModal"
      @onCloseModal="closeModal"
    />

    <add-file-form-modal
      v-if="currentFolder.id && showAddFileFormModal"
      :currentFolder="currentFolder"
      :showModal="showAddFileFormModal"
      @onCloseModal="closeModal"
    />

    <file-form-modal
      v-if="currentFolder && showFileFormModal"
      :currentFolder="currentFolder"
      :fileData="fileData"
      :showModal="showFileFormModal"
      @onCloseModal="closeModal"
    />

    <file-history-modal
      v-if="currentFolder.id"
      :fileData="fileData"
      :showModal="showFileHistoryModal"
      @onCloseModal="closeModal"
    />
  </div>
</template>

<script>
import swal from "sweetalert2";
import requestErrorMixin from "@/mixins/request-error-mixin";
import FilesGrid from "./partials/FilesGrid.vue";
import FolderFormModal from "./partials/FolderFormModal.vue";
import FileFormModal from "./partials/FileFormModal.vue";
import FileHistoryModal from "./partials/FileHistoryModal.vue";
import FilesList from "./partials/FilesList.vue";
import AddFileFormModal from "./partials/AddFileFormModal.vue";
import NotificationSubscription from "@/components/NotificationSubscription.vue";

const VIEW_GRID = "GRID";
const VIEW_LIST = "LIST";

export default {
  components: {
    FolderFormModal,
    FilesGrid,
    FileFormModal,
    FileHistoryModal,
    FilesList,
    AddFileFormModal,
    NotificationSubscription,
  },

  mixins: [requestErrorMixin],

  computed: {},

  data() {
    const currentFolderData = {
      id: null,
      name: "/",
      subfolders: [],
      files: [],
      allowedLocations: [],
      roles: [],
      users: [],
      organization: {
        type: "organizations",
        id: null,
      },
      breadcrumbs: [
        {
          id: null,
          name: "/",
        },
      ],
      full_path: "/",
    };

    const me = this.$store.getters["profile/me"];

    return {
      me: me,
      breadCrumbs: [],
      currentFolder: currentFolderData,
      showFolderFormModal: false,
      showFileFormModal: false,
      showAddFileFormModal: false,
      folderData: null,
      fileData: null,
      showFileHistoryModal: false,
      selectedItems: [],
      renderKey: 0,
      view: VIEW_GRID,
      VIEW_GRID: VIEW_GRID,
      VIEW_LIST: VIEW_LIST,
      query: null,
      searchContextCaptured: false,
      searchContext: {
        folderId: null,
        breadcrumbs: [],
      },
      skipNextQueryWatcher: false,
    };
  },

  async created() {
    await this.get(this.$route.query.folder_id);
    if (this.$route.query.file_id) {
      this.openEditFileModal({ id: this.$route.query.file_id });
    }
  },

  methods: {
    cloneBreadcrumbs(breadcrumbs = []) {
      return (breadcrumbs || []).map((item) => ({ ...item }));
    },

    computeFullPathFromBreadcrumbs(breadcrumbs = []) {
      const segments = (breadcrumbs || [])
        .filter((crumb) => crumb.id !== null)
        .map((crumb) => crumb.name);
      if (!segments.length) {
        return "/";
      }
      return `/${segments.join("/")}`;
    },

    clearSearchContext() {
      this.searchContextCaptured = false;
      this.searchContext = {
        folderId: null,
        breadcrumbs: [],
      };
    },

    exitSearchMode() {
      this.clearSearchContext();
      this.skipNextQueryWatcher = true;
      this.query = null;
    },

    debouncedSearch: _.debounce(function () {
      this.search();
    }, 300),

    async get(id = null) {
      if (this.query && this.searchContextCaptured) {
        this.exitSearchMode();
      }
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      if (id) {
        await this.getFolder(id);
      } else {
        await this.getRootFolder();
      }
      this.selectedItems = [];
      swal.close();
    },

    async getRootFolder() {
      try {
        const params = {
          sort: "name",
          filter: {
            parent: null,
          },
          page: {
            number: 0,
            size: 999999,
          },
          include: "organization,tags,allowedLocations",
        };

        await this.$store.dispatch("folders/list", params);
        const folders = this.$store.getters["folders/list"];
        const folder = {
          id: null,
          name: "/",
          subfolders: folders,
          files: [],
          allowedLocations: [],
          roles: [],
          users: [],
          organization: {
            type: "organizations",
            id: null,
          },
        };
        folder.breadcrumbs = [
          {
            id: null,
            name: "/",
          },
        ];
        folder.full_path = this.computeFullPathFromBreadcrumbs(
          folder.breadcrumbs
        );
        this.clearSearchContext();
        this.currentFolder = folder;
      } catch (error) {
        this.showRequestError(error);
      }
    },

    async search() {
      try {
        const folderIdFilter = this.searchContextCaptured
          ? this.searchContext.folderId
          : null;
        const searchFoldersParams = {
          sort: "name",
          filter: {
            search: this.query,
          },
          page: {
            number: 0,
            size: 999999,
          },
          include: "organization,tags,allowedLocations",
        };
        if (folderIdFilter !== null && folderIdFilter !== undefined) {
          searchFoldersParams.filter.parent = folderIdFilter;
        }

        await this.$store.dispatch("folders/list", searchFoldersParams);
        const folders = this.$store.getters["folders/list"];

        const searchFilesParams = {
          sort: "name",
          filter: {
            search: this.query,
            // Les pièces jointes d'évènements restent hors de l'explorateur.
            excludeObjectType: "events",
          },
          page: {
            number: 0,
            size: 999999,
          },
          include: "organization,tags,allowedLocations,folder",
        };
        if (folderIdFilter !== null && folderIdFilter !== undefined) {
          searchFilesParams.filter.folder = folderIdFilter;
        }
        // Sans « voir tous les fichiers », l'API refuse la liste : la recherche ne porte que sur les dossiers.
        let files = [];
        if (this.$currentUserCan(this.$permissions.PERM_VIEW_ANY_FILES)) {
          await this.$store.dispatch("files/list", searchFilesParams);
          files = this.$store.getters["files/list"];
        }

        const breadcrumbs =
          this.searchContextCaptured && this.searchContext.breadcrumbs.length
            ? this.cloneBreadcrumbs(this.searchContext.breadcrumbs)
            : [
                {
                  id: null,
                  name: "/",
                },
              ];
        const folder = {
          id: null,
          name: "/",
          subfolders: folders,
          files: files,
          allowedLocations: [],
          roles: [],
          users: [],
          organization: {
            type: "organizations",
            id: null,
          },
        };
        folder.breadcrumbs = breadcrumbs;
        folder.full_path = this.computeFullPathFromBreadcrumbs(breadcrumbs);
        this.currentFolder = folder;
        this.selectedItems = [];
      } catch (error) {
        this.showRequestError(error);
      }
    },

    async getFolder(id) {
      try {
        await this.$store.dispatch("folders/get", id);
        this.currentFolder = this.$store.getters["folders/folder"];
      } catch (error) {
        this.showRequestError(error);
      }
    },

    openNewFolderModal() {
      this.closeModal();
      this.showFolderFormModal = true;
    },

    openNewFileModal() {
      this.closeModal();
      this.showAddFileFormModal = true;
    },

    async openFileHistoryModal() {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      this.closeModal();
      try {
        await this.$store.dispatch("files/get", this.selectedItems[0].id);
        this.fileData = this.$store.getters["files/file"];
        this.showFileHistoryModal = true;
      } catch (error) {
        this.showRequestError(error);
      }
      swal.close();
    },

    async openEditModal() {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      this.closeModal();
      const selectedItem = this.selectedItems[0];
      if (selectedItem.type === "folders") {
        await this.openEditFolderModal(selectedItem);
      } else if (selectedItem.type === "files") {
        await this.openEditFileModal(selectedItem);
      }
      swal.close();
    },

    async openEditFolderModal(selectedItem) {
      try {
        await this.$store.dispatch("folders/get", selectedItem.id);
        this.folderData = this.$store.getters["folders/folder"];
        this.showFolderFormModal = true;
        this.renderKey = this.renderKey + 1;
      } catch (error) {
        this.showRequestError(error);
      }
    },

    async openEditFileModal(selectedItem) {
      try {
        await this.$store.dispatch("files/get", selectedItem.id);
        this.fileData = this.$store.getters["files/file"];
        this.showFileFormModal = true;
        this.renderKey = this.renderKey + 1;
      } catch (error) {
        this.showRequestError(error);
      }
    },

    openSelectedLocation() {
      if (!this.canOpenLocation()) {
        return;
      }
      const [selected] = this.selectedItems;
      const folderId = this.resolveItemFolderId(selected);
      if (folderId === undefined) {
        return;
      }
      this.get(folderId);
    },

    resolveItemFolderId(item) {
      if (!item) {
        return undefined;
      }
      if (item.type === "folders") {
        return item.id;
      }
      if (item.type === "files") {
        const folderRelation =
          item.folder ||
          item.folderData ||
          item.relationships?.folder?.data ||
          item.relationships?.folder ||
          null;
        const folderId =
          folderRelation?.id ??
          folderRelation?.data?.id ??
          item.folder_id ??
          item.folderId;
        return folderId;
      }
      return undefined;
    },

    async closeModal(refresh) {
      if (refresh) {
        await this.get(this.currentFolder.id);
      }
      this.showFolderFormModal = false;
      this.folderData = null;
      this.showAddFileFormModal = false;
      this.showFileFormModal = false;
      this.fileData = null;
      this.showFileHistoryModal = false;
    },

    async deleteItems() {
      const confirmation = await swal.fire({
        title: this.$t("FILES.DELETE_THIS_ITEM"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });

      try {
        if (confirmation.value === true) {
          for (const item of this.selectedItems) {
            if (item.type === "folders") {
              await this.$store.dispatch("folders/destroy", item.id);
            } else if (item.type === "files") {
              await this.$store.dispatch("files/destroy", item.id);
            }
          }
          await this.get(this.currentFolder.id);
          this.$notify({
            type: "success",
            message: this.$t("LOCATIONS.LOCATION_DELETED"),
          });
        }
        this.renderKey = this.renderKey + 1;
      } catch (error) {
        this.showRequestError(error);
      }

      swal.close();
    },

    canViewHistory() {
      if (this.selectedItems.length === 1) {
        if (this.selectedItems[0].type === "files") {
          return true;
        }
      }
      return false;
    },

    canEdit() {
      const selectedItemsHasLockedFolder = this.selectedItems.some((item) => {
        if (item.type === "folders") {
          return item.locked;
        }
        return false;
      });
      if (selectedItemsHasLockedFolder) {
        if (
          !this.$currentUserCan(this.$permissions.PERM_MANAGE_LOCKED_FOLDERS)
        ) {
          return false;
        }
      }

      if (this.selectedItems.length === 1) {
        if (this.selectedItems[0].type === "files") {
          return this.$currentUserCan(this.$permissions.PERM_EDIT_FILES);
        }
        if (this.selectedItems[0].type === "folders") {
          return this.$currentUserCan(this.$permissions.PERM_EDIT_FOLDERS);
        }
      }
      return false;
    },

    canDelete() {
      const selectedItemsHasLockedFolder = this.selectedItems.some((item) => {
        if (item.type === "folders") {
          return item.locked;
        }
        return false;
      });
      if (selectedItemsHasLockedFolder) {
        if (
          !this.$currentUserCan(this.$permissions.PERM_MANAGE_LOCKED_FOLDERS)
        ) {
          return false;
        }
      }

      for (const item of this.selectedItems) {
        if (item.type === "files") {
          if (!this.$currentUserCan(this.$permissions.PERM_DELETE_FILES)) {
            return false;
          }
        }
        if (item.type === "folders") {
          if (!this.$currentUserCan(this.$permissions.PERM_DELETE_FOLDERS)) {
            return false;
          }
        }
      }
      return true;
    },

    canDoActions() {
      const selectedItemsHasLockedFolder = this.selectedItems.some((item) => {
        if (item.type === "folders") {
          return item.locked;
        }
        return false;
      });
      if (selectedItemsHasLockedFolder) {
        if (
          !this.$currentUserCan(this.$permissions.PERM_MANAGE_LOCKED_FOLDERS)
        ) {
          return false;
        }
      }

      return this.selectedItems.length > 0;
    },

    canOpenLocation() {
      if (this.selectedItems.length !== 1) {
        return false;
      }
      const folderId = this.resolveItemFolderId(this.selectedItems[0]);
      return folderId !== undefined;
    },
  },

  watch: {
    currentFolder(currentFolder) {
      if (!currentFolder) {
        this.breadCrumbs = [];
        return;
      }
      if (currentFolder.breadcrumbs && currentFolder.breadcrumbs.length) {
        this.breadCrumbs = this.cloneBreadcrumbs(currentFolder.breadcrumbs);
        return;
      }
      const currentFolderIndex = this.breadCrumbs.findIndex(
        (item) => item.id === currentFolder.id
      );
      if (currentFolderIndex >= 0) {
        this.breadCrumbs = this.breadCrumbs.slice(0, currentFolderIndex + 1);
      } else {
        this.breadCrumbs.push({
          id: currentFolder.id,
          name: currentFolder.name,
        });
      }
    },
    query(query) {
      if (this.skipNextQueryWatcher) {
        this.skipNextQueryWatcher = false;
        return;
      }
      if (query) {
        if (!this.searchContextCaptured) {
          this.searchContextCaptured = true;
          this.searchContext = {
            folderId: this.currentFolder.id,
            breadcrumbs: this.cloneBreadcrumbs(this.breadCrumbs),
          };
        }
        this.debouncedSearch();
        return;
      }
      const hasContext = this.searchContextCaptured;
      const folderId = this.searchContext.folderId;
      this.clearSearchContext();
      if (hasContext && folderId !== null && folderId !== undefined) {
        this.get(folderId);
      } else {
        this.getRootFolder();
      }
    },
  },
};
</script>

<style scoped>
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #8898aa;
  content: ">";
}
</style>
